// extracted by mini-css-extract-plugin
export default {"container":"notification-module__container--V28Yj"};